module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-foreword element-with-heading",
    attrs: {
      "id": "foreword"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "foreword-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('h1', {
    staticClass: "number-and-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("By Cheryl Hawkins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "foreword-text"
    }
  }, [_c('h2', {
    staticClass: "section-title subhead"
  }, [_vm._v("A Transformation Unfolds and the Journey Goes")]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width first-after-subhead"
  }, [_vm._v("From early teens to maybe age 30, I was energetic, physically active, and focused. After a series of unforeseen events, my body suffered severe injuries from unexplained accidents. I began to yield to symptomatic and chronic pain. The pain spiraled me into the depths of severe obesity, disease, and depression from the vicious cycles. At the close of 2014, it appeared that only miraculous healing could change the outcome of my future.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Wouldn’t you know, I just happened to be at our traditional Christmas family gathering to watch Jason Berry open his brand new set of Digital Dumbbells. Within minutes of unwrapping the equipment, he began to share how excited he was about finishing his book and mentioned that if I desired to start a workout program, he would make himself available.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My first horrific thoughts were, “Oh no, are you kidding, do you realize how fragile my framework is...did you forget I was the one at your summer boot camp who couldn’t hold a water jug, who couldn’t stand up for the five-minute warmup, who bailed out and never finished, completed, or got through one session...that body!” Followed with the thought, “My joints are so impaired, after eight weeks of physical therapy in November, there was no improvement.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But then my mind flipped over to what if, “what if he can really help me, what if I "), _c('i', [_vm._v("can")]), _vm._v(" feel better, what if these bones "), _c('i', [_vm._v("can")]), _vm._v(" live again?” It wasn’t the fact that he offered; it was the way he said it and the faith guarantee behind it. I consented and decided to let him train me. Praise God for that decision!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As of this writing, it has been seven miraculous, overcoming months since the start of a new mindset and workout sessions with Jason. My energy level has tripled, my cellular, molecular, structural, and cardio levels have improved, pounds have flown off, measurements have shrunk, and I AM THE HEALED OF THE LORD! Every week I thank God for new victories, new goals, new accomplishments, and less of me when I see my reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("You may be wondering or thinking, “There was no mentioning about the exact number of pounds, inches, nor dress sizes lost.” The reason is that at the end of the day, when the music stops, what is most important to me is that this transformation has a divine supernatural purpose in the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thank you, Jason, for filling a void in the body of Christ. I think everyone needs to have a copy of this book. It is powerful and anointed teaching. As a reader, you’re in for a real treat. Get ready to go on a journey, just like I did.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Cheryl Hawkins")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91ade568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foreword.vue
// module id = 69
// module chunks = 0